import { useAuth } from '@/lib/auth';
import { Lock, Clock } from 'lucide-react';

export function useProgramLocked() {
  const { user } = useAuth();
  return user?.role === 'client' && !!user?.status && user.status !== 'active';
}

export function LockedScreen({ title, color = '#00C8FF' }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-20 px-4" data-testid="program-locked-screen">
      <div className="w-20 h-20 rounded-3xl flex items-center justify-center mb-6" style={{ background: `${color}1a` }}>
        <Lock className="w-9 h-9" style={{ color }} strokeWidth={2.2} />
      </div>
      <h2 className="font-display font-black text-2xl">{title} is Locked</h2>
      <p className="text-sm text-muted-foreground mt-3 max-w-sm leading-relaxed">
        Your personalized YourReGen program is currently being prepared by Coach JP. Please allow up to 24 hours.
        You'll get a notification the moment it's ready.
      </p>
      <div className="mt-6 inline-flex items-center gap-2 pill bg-[var(--c-film)] text-muted-foreground text-xs">
        <Clock className="w-3.5 h-3.5" /> Preparing your personalized program
      </div>
    </div>
  );
}
